import { render, staticRenderFns } from "./EditFull.vue?vue&type=template&id=24b9db37&scoped=true"
import script from "./EditFull.vue?vue&type=script&lang=js"
export * from "./EditFull.vue?vue&type=script&lang=js"
import style0 from "./EditFull.vue?vue&type=style&index=0&id=24b9db37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b9db37",
  null
  
)

export default component.exports